varying vec2 vUv; 
varying vec3 vNormal; 
varying vec3 vPos; 
varying vec3 vWorldPos; 
void main(){


    vec4 modelPosition = modelMatrix * vec4(position, 1.0);



    vec4 viewPosition =  viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;


    // aditionnal calculations
    vUv = uv;
    vNormal = normal;
    vPos = position;
    vWorldPos = modelPosition.xyz;

}